const getDisplayValueForTextFields = (receivedValue: any, action:string):string => {
    if(action !== 'create' && !receivedValue)
        return JSON.stringify(receivedValue)
    else
        return receivedValue
}

export {getDisplayValueForTextFields};
